module.exports = __webpack_public_path__ + "static/media/worker-c.fed0440b.png";